import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-booking',
  templateUrl: './pricing-booking.component.html',
  styleUrls: ['./pricing-booking.component.css']
})
export class PricingBookingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/component/pricing-booking/pricing-booking.component.ts